import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { PROPERTIES } from '../constants';
import { FormStatus } from '../types';
import FormsStatusTag from './name/FormsStatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
function StatusCell({
  crmObject,
  propertyName
}) {
  const statusPropertyValue = getPropertyValue(crmObject, propertyName);
  const isPublished = statusPropertyValue === FormStatus.PUBLISHED;
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  return /*#__PURE__*/_jsx(FormsStatusTag, {
    status: statusPropertyValue,
    formType: formType,
    isPublished: isPublished
  });
}
export const status = {
  width: 135,
  renderCell: props => /*#__PURE__*/_jsx(StatusCell, Object.assign({}, props))
};